import React,{useState} from 'react';
import HeaderBar from './js/headerbar';
import Deleteable from './js/deletable';
import ArrowButton from './js/arrow_button';
import Loader from './js/loader';
import {MultipleMediaControl} from './js/customizer';
import {NewsletterSignUpBlock, FollowUsBlock} from './js/blocks';
import {EventsCarousel} from './js/events';
import {HighlightedText} from './js/highlightedtext';
import HoverImageTile from './js/hoverimagetile';
import SICArchive from './js/sicarchive';
import SICPost from './js/sicpost';
import Sidebar from './js/sidebar';
import TitleArea from './js/titlearea';
import ContactForm from './js/blocks/contact';
import IndentedHeader from './js/blocks/indented_header';

/*
"Thanks to Our Sponsors" turns white and goes in the blue footer
Fix customizer
*/

const {
    wpQuery,
    getWPJSON,
    util: {uuidv4},
    components: {
        generic: {Image, Masonry}
    },
    hooks: {
       usePromise, useBreakpoint,
       useStateWithCallback, useSelector,
       useHover, useResize
    },
    css: {prefixCSS},
    hoc: {withExplicitProps, withNoProps}
} = polyphony;

const BasicField = ({label, children, style}) => {
    return (
        <div style={{...prefixCSS({display: 'flex', flexFlow: 'column nowrap', alignItems: "flex-start", width: '100%'}), ...style}}>
            <div style={{paddingBottom: 5}}>{label}</div>
            {children}
        </div>
    );
};

const TextField = ({label, type='text', onChange, transform = v => v, value, style}) => {
    return (
        <BasicField label={label} style={style}>
            <input type={type} value={value || ''} onChange={e => onChange(transform(e.target.value))} />
        </BasicField>
    );
};

const ChoiceField = ({label, onChange, checked}) => {
    return (
        <div style={prefixCSS({display: 'flex', flexFlow: 'row nowrap', alignItems: 'flex-end', alignContent: 'center'})}>
            <input type="checkbox" onChange={e => onChange(e.target.checked)} checked={checked} />
            <label>{label}</label>
        </div>
    );
};

const CoordinatePicker = ({x: ix, y: iy, onChangeX, onChangeY, style}) => {
    const [x, setX] = useStateWithCallback(ix, onChangeX);
    const [y, setY] = useStateWithCallback(iy, onChangeY);
    const click = e => {
        const clickx = e.pageX;
        const clicky = e.pageY - scrollY;
        const {top, left, width, height} = e.target.getBoundingClientRect();
        setX((clickx - left) / width);
        setY((clicky - top) / height);
    };

    const dimension = 11;

    return (
        <div style={{position: 'relative', paddingTop: `calc(${1080} / ${1920} * 100%)`, height: 0, background: 'gray', ...style}}>
            <div style={prefixCSS({position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                                   display: 'flex', justifyContent: 'center', alignItems: 'center'})} onClick={click}>
                <span style={{color: 'white', fontSize: 20, fontWeight: 'bold', pointerEvents: 'none'}}>16:9</span>
            </div>
            <div style={{borderRadius: dimension, position: 'absolute', top: `calc(${Math.trunc(y * 1000) / 10}% - ${dimension / 2}px)`, left: `calc(${Math.trunc(x * 1000) / 10}% - ${dimension / 2}px)`, width: dimension, height: dimension, background: 'black'}} />
        </div>
    );
};

const SlideMetaBox = ({setJSON, json: initialJSON}) => {
    const useJSONState = (k, i) => {
        React.useDebugValue(k);
        const [json, setJState] = useState(initialJSON);

        let initial = k.split('.').reduce((acc, key) => acc ? acc[key] : acc, json);
        if (initial === undefined) {
            initial = i;
        }

        const callback = v => {
            let obj = json;
            let head = k.split('.');
            let tail = head.pop();
            head.forEach(k => {
                let t = obj[k];
                if (t === undefined) {
                    obj[k] = {};
                    t = {};
                }
                obj = t;
            });
            obj[tail] = v;
            setJState(json);
            setJSON(json);
        };

        return useStateWithCallback(initial, callback);
    };

    const [order, setOrder] = useJSONState('order', null);
    const [href, setHref] = useJSONState('href', null);
    const [effectType, setEffectType] = useJSONState('effect_type', null);
    const [duration, setDuration] = useJSONState('duration', 10.0);
    const [x, setX] = useJSONState('coordinate.x', 0.5);
    const [y, setY] = useJSONState('coordinate.y', 0.5);
    const [zoomFactor, setZoomFactor] = useJSONState('zoomFactor', 2);

    return (
        <>
            <span style={{display: 'block', fontSize: 19, marginBottom: 5}}>Slide Basics</span>
            <TextField label="Link Target" value={href} onChange={setHref} />
            <br />
            <TextField label="Order in Slideshow" value={order} onChange={setOrder}
                                                 type='number' transform={parseInt} />
            <br />
            <span style={{display: 'block', fontSize: 19, marginTop: 3}}>Ken Burns Effect</span>
            <br />
            <ChoiceField checked={effectType === 'kenburns'} onChange={v => setEffectType(v ? 'kenburns' : null)} label="Enabled" />
            {effectType === 'kenburns' && <>
            <br />
            <TextField label="Duration (Seconds)" value={duration} onChange={setDuration}
                                                     type='number' transform={parseFloat} />
            <br />
            <TextField label="Zoom Factor" value={zoomFactor} onChange={setZoomFactor}
                                                     type='number' transform={parseFloat} />
            <br />
            <BasicField label="Zoom Point">
                <div style={{width: 300}}>
                    <CoordinatePicker x={x} y={y} onChangeY={setY} onChangeX={setX} style={{width: '100%'}} />
                </div>
            </BasicField>
            </>}
        </>
    );
};

window.polyphony_child = {
    render: {
        slide_meta_box: (input_id, container_id) => {
            const input = document.getElementById(input_id);
            const setJSON = j => input.value = JSON.stringify(j);
            let json = input.value ? JSON.parse(input.value) : null;
            if (!json) json = {};
            window.ReactDOM.render(<SlideMetaBox setJSON={setJSON} json={json} />,
                                   document.getElementById(container_id));
        }
    }
};

polyphony.addBlock(EventsCarousel);

const listify = as => {
    let x = [...as];
    if (x.length > 2) {
        x[x.length - 1] = '& ' + x[x.length - 1];
    }
    return x.join(', ');
};

const categories = post => {
    let cs = post.taxonomies.category || [];
    cs = cs.filter(c => c.slug !== 'uncategorized');
    return cs.map(c => c.name);
};

const BlogrollTile = ({post, isEditor}) => {
    const {meta, title, featured_media, permalink} = post;
    const {tile_title, tile_background} = meta;

    let timage = tile_background ? tile_background : featured_media ? featured_media.default : null;
    let ttitle = tile_title ? tile_title : title;

    if (timage && Object.keys(timage).length === 0) {
        timage = null;
    }

    let tcats = listify(categories(post));

    return (
        <HoverImageTile hideOutline href={permalink} clickable={!isEditor} media={timage} childStyle={prefixCSS({padding: 20, boxSizing: 'border-box', display: 'flex', justifyContent: 'center', flexFlow: 'column nowrap'})}>
            {tcats && <HighlightedText style={{width: '100%', fontSize: 20, position: 'relative', top: 3}}>{tcats}</HighlightedText>}
            <HighlightedText style={{width: '100%', fontSize: 30}}>{ttitle}</HighlightedText>
            <ArrowButton tag='div' style={{marginTop: 10}}>Read more</ArrowButton>
        </HoverImageTile>
    );
};

const PostsMasonry = ({count=6, isEditor}) => {
    const {loading, result} = usePromise(() => wpQuery('/', {orderby: 'highlight', per_page: count, highlights_only: '1'}), [count]);

    if (loading) {
        return <Loader />;
    }

    return <Masonry unitsWide={3} style={{width: '100%'}}>
       {result.posts.map((p, i) => <Masonry.Tile key={i} widthUnits={1} heightUnits={1}><BlogrollTile isEditor={isEditor} post={p} /></Masonry.Tile>)}
    </Masonry>;
};

const PostsMasonryBlock = ({gutenberg:{isEditor}, ...props}) => <PostsMasonry isEditor={isEditor} {...props} />;
PostsMasonryBlock.title = 'Post Masonry';
PostsMasonryBlock.icon = 'wp';
PostsMasonryBlock.category = 'layout';
polyphony.addBlock(PostsMasonryBlock);

const LinkButtonBlock = ({gutenberg:{isEditor, setProp}, text, href, fontSize}) => {
    let editorControls = null;
    if (isEditor) {
        const { InspectorControls } = window.wp.blockEditor;
        const { TextControl } = window.wp.components;
        editorControls =
            <div key="asdf">
                <InspectorControls key='editor-controls'>
                    <TextControl label="Button Text" value={text} onChange={text => setProp('text', text)} />
                    <TextControl label="Link Target" value={href} placeholder='https://' onChange={href => setProp('href', href)} />
                    <TextControl label="Font Size" value={fontSize} onChange={v => setProp('fontSize', v)} />
                </InspectorControls>
            </div>
        ;
    }

    return [
        editorControls,
        <ArrowButton key="asdf4" href={href} style={{fontSize}}>{text}</ArrowButton>
    ];
};

LinkButtonBlock.title = "Link Button";
LinkButtonBlock.icon = 'wp';
LinkButtonBlock.category = 'layout';
polyphony.addBlock(LinkButtonBlock);

const FooterMenuItem = withExplicitProps(({url, title}) => {
    const [{hover}, ref] = useHover();
    return (
        <a role="menuitem" ref={ref} href={url} style={{fontSize: 17.5, padding: 12.5, margin: 12.5, textTransform: 'uppercase', boxSizing: 'border-box', color: hover ? 'lightgray' : 'inherit'}}>
            {title}
        </a>
    );
}, ['url', 'title']);

const Footer = withNoProps(() => {
    const menuItems = useSelector(s => s.menus['footer-menu'].items); // TODO: better compare
    const maxWidth = useSelector(s => s.measurements.max_width);
    const iconHeight = useSelector(s => s.measurements.footer_logo_height);
    const backgroundColor = useSelector(s => s.footer.background_color);
    const tagline = useSelector(s => s.footer.tagline);
    const logos = useSelector(s => s.footer.logos); // TODO: better compare

    const styles = {
        logoAreaWrapper: prefixCSS({
            backgroundColor,
            display: 'flex',
            alignItems: 'center',
            flexFlow: 'column nowrap',
            width: '100%',
            boxSizing: 'border-box',
            padding: 20
         }),
        logoWrapper: prefixCSS({
            width: '100%',
            maxWidth,
            display: 'flex',
            flexFlow: 'row wrap',
            justifyContent: 'center'
        }),
        logo: {
            height: iconHeight,
            padding: 10,
            boxSizing: 'border-box',
            maxWidth: '100%',
            display: 'block',
            objectFit: 'contain'
        },
        nav: prefixCSS({
            width: '100%',
            display: 'flex',
            flexFlow: 'row wrap',
            justifyContent: 'center'
        })
    };

    return (
        <footer role="contentinfo" className="footer">
            <div role="none" style={styles.logoAreaWrapper}>
                <h2 style={{textAlign: 'center', margin: 10, color: 'white'}}>{tagline}</h2>
                <div role="list" style={styles.logoWrapper}>
                    {logos && logos.map(({sic_link, ...img}, idx) =>
                    <a role="listitem" key={`${img.id} ${idx}`} href={sic_link} style={{color: 'white', maxWidth: `100%`, display: 'inline-block'}}>
                       <Image lazy media={img} style={styles.logo} />
                    </a>
                    )}
                </div>
            </div>
            <nav role="menubar" style={styles.nav} aria-label='Footer Navigation'>
                {menuItems.map((item, idx) => <FooterMenuItem key={idx} title={item.title} url={item.url} />)}
            </nav>
        </footer>
    );
});


const ContentWrapper = ({children}) => {
    const width = useResize().width;
    const isHome = useSelector(s => s.is.front_page);
    const isMobile = useBreakpoint() === 'mobile';
    const maxWidth = useSelector(s => s.measurements.max_width);
    const paddingTop = useSelector(s => s.measurements.page_margin_top);
    const paddingBottom = useSelector(s => s.measurements.page_margin_bottom);
    const paddingLeft = useSelector(s => s.measurements.page_margin_left);
    const paddingRight = useSelector(s => s.measurements.page_margin_right);

    const styles = {
        outer: prefixCSS({
            display: "flex",
            flexFlow: 'column nowrap',
            minHeight: '100vh',
            position: 'relative'
        }),
        inner: prefixCSS({
            flexGrow: 2
        }),
        childrenOuter: prefixCSS({
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'center',
            boxSizing: 'border-box',
            width: '100%',
            paddingTop, paddingBottom, paddingRight, paddingLeft
        }),
        childWrapper: prefixCSS({
            display: 'flex',
            flexFlow: 'column nowrap',
            maxWidth: width > 862 ? 800 : '100%',
            boxSizing: 'border-box',
            paddingRight: isMobile || isHome ? undefined : 90, // 90 - archives, 130 - page
            width: isMobile ? '100%' : undefined,
            flex: isMobile ? undefined : '2 0 66%'
        }),
        outerContainer: prefixCSS({
            display: 'flex',
            flexFlow: 'row wrap',
            width: '100%',
            maxWidth,
            justifyContent: 'center'
        })
    };

    return (
        <div role="none" style={styles.outer}>
          <div role="none" style={styles.inner}>
              <HeaderBar />
              <TitleArea />
              <div role="none" style={styles.childrenOuter} id="content-wrapped-page">
                  <div role="none" style={styles.outerContainer}>
                      <div role="none" style={styles.childWrapper}>
                          {children}
                       </div>
                      {!isHome && <div role="none" style={prefixCSS({width: isMobile ? '100%' : undefined, flex: isMobile ? undefined : '1 2 33%', maxWidth: '100%'})}>
                          <Sidebar />
                      </div>}
                  </div>
              </div>
          </div>
          <Footer />
        </div>
    );
};

polyphony.setContentWrapper(ContentWrapper);
polyphony.setArchiveComponent('post', SICArchive);
polyphony.setArchiveComponent('event', SICArchive);
polyphony.setPostComponent('page', SICPost);
polyphony.setPostComponent('post', SICPost);
polyphony.setPostComponent('event', SICPost);
polyphony.setLoadingIndicator(() => <Loader fullscreen />);

polyphony.registerCustomizerControl('multiple_images', MultipleMediaControl);

const swapped = (_ary, from, to) => {
   let ary = [..._ary];
   const tmp = ary[from];
   ary[from] = ary[to];
   ary[to] = tmp;
   return ary;
};

const updatedAt = (ary, idx, update = {}) => [
    ...ary.slice(0, idx),
    {...ary[idx], ...update, n: ary[idx].n + 1},
    ...ary.slice(idx + 1)
];


const SidebarBox = ({idx, setBoxes, boxes}) => {
    const isLast = idx === boxes.length - 1;
    const isFirst = idx === 0;

    const {MediaPicker} = polyphony.components.backend;

    const setImage = image => setBoxes(updatedAt(boxes, idx, {image}));
    const textChanged = text => setBoxes(updatedAt(boxes, idx, {text}));
    const hrefChanged = href => setBoxes(updatedAt(boxes, idx, {href}));
    const remove = () => {
        setBoxes([...boxes.slice(0, idx), ...boxes.slice(idx + 1)]);
    };

    const moveUp = () => setBoxes(swapped(boxes, idx, idx - 1));
    const moveDown = () => setBoxes(swapped(boxes, idx, idx + 1));

    const {image, text, href} = boxes[idx];

    return <Deleteable onUp={!isFirst && moveUp} onDown={!isLast && moveDown} onDelete={remove} style={{width: '100%', paddingBottom: idx < boxes.length - 1 ? 30 : undefined}}>
        <div style={{padding: 10, boxSizing: 'border-box', width: '100%', border: '1px solid lightgray'}}>
            <MediaPicker media={image} onMediaChange={setImage} style={{marginBottom: 10}}/>
            <TextField label='Text' onChange={textChanged} value={text} key='text' style={{marginBottom: 10}} />
            <TextField label='Link' onChange={hrefChanged} value={href} key='link' />
        </div>
    </Deleteable>;
};

const styles = {
   addButton: prefixCSS({cursor: 'pointer', height: 44, display: 'flex', flexFlow: 'column nowrap', justifyContent: 'center'})
};

const SidebarBoxesControl = ({state: boxes, setState: setBoxes}) => [
    boxes.map((box, idx) =>
    <SidebarBox key={box.guid} idx={idx}
                setBoxes={setBoxes} boxes={boxes} />
    ),
    <div style={styles.addButton} key="add_box"
         onClick={() => setBoxes([...boxes, {image: null, text: '', href: '', n: 0, guid: uuidv4()}])}>+ Box</div>
];
SidebarBoxesControl.defaultState = [];

const buildUrl = (base, ps) => {
    let u = new URL(base, window.location.origin);
    for (const x of Object.entries(ps)) u.searchParams.set(...x);
    return u.toString();
};

const ConstantContactCustomizer = ({state, setState, redirectUrl}) => {
    const {client_id, client_secret, token, list_id} = state || {};
    const {loading, result} = usePromise(
        () => !token ? new Promise(r => r(null)) : getWPJSON("/polyphony-child/v1/get_lists/"),
        [Boolean(token)]
    );

    const clientIdChanged = v => setState({...state, client_id: v === '' ? null : v});
    const clientSecretChanged = v => setState({...state, client_secret: v === '' ? null : v});
    const listIdChanged = v => setState({...state, list_id: v === '' ? null : v});

    const revoke = () => setState({...state, token: null});

    const authorizationUrl = buildUrl("https://api.cc.email/v3/idfed?", {
        client_id: client_id,
        scope: 'contact_data',
        response_type: 'code',
        redirect_uri: redirectUrl
    });

    const styles = {
        a: {
            margin: '10px 0',
            display: 'block'
        }
    };

    return <>
        <TextField label='Client ID' onChange={clientIdChanged} value={client_id} key='client_id' />
        <br />
        <TextField label='Client Secret' onChange={clientSecretChanged} value={client_secret} key='client_secret' />
        {!token && <a style={styles.a} href={authorizationUrl}>Authorize</a>}
        {token && <a style={styles.a} href="#" onClick={revoke}>Revoke Token</a>}
        {loading && <Loader style={{height: 64}}/>}
        {!loading && result && result.success && <BasicField label="Contacts List/Email List">
        <select defaultValue={list_id ? list_id : ''} onChange={e => listIdChanged(e.target.value)}>
            <option value='' key="placeholder">Don't use a contacts list</option>
            {result.lists.map((x, idx) => <option key={`${idx} ${x.list_id}`} value={x.list_id}>{x.name}</option>)}
        </select>
        <p style={{fontStyle: 'italic', margin: '0.5em 0'}}>When visitors use the newsletter sign up block, their email address will be added to this list on Constant Contact.</p>
        </BasicField>}
        <br />
    </>;
};

polyphony.registerCustomizerControl('sidebar_boxes', SidebarBoxesControl);
polyphony.registerCustomizerControl('constant_contact', ConstantContactCustomizer);
polyphony.addBlock(IndentedHeader);
polyphony.addBlock(NewsletterSignUpBlock);
polyphony.addBlock(FollowUsBlock);
polyphony.addBlock(ContactForm);
polyphony.setHashScrollOffset(100);

